export default "/images/vendor/quill/icons/clean.svg?d59691df45537ae1a2637d373cdb3c90";